export default __webpack_public_path__ + "images/9ee45612837f21b74f9f5b429672e079.gif";